import { Menu, Status } from "@common/models";
import { ReportType } from "./report-type";
import { ReportCategory } from "./report-category";

export class ReportMenuId {
    report?: Report;
    menu?: Menu;
}

export class ReportMenu {
    id?: ReportMenuId;
}

/** Datos del usuario que publicó el reporte (vista de solo lectura del backend) */
export class ReportUser {
    id?: number;
    /** Nombre de la persona (common.person.name) */
    name?: string;
    /** Apellido de la persona (common.person.surname) */
    surname?: string;
    /** Respaldo para usuarios sin persona asociada */
    username?: string;
}

export class Report {
    id?: number;
    title?: string;
    titleEnglish?: string;
    description?: string;
    serverUrl?: string;
    serverReferenceId?: string;
    serverReferenceIdEnglish?: string;
    groupId?: string;
    ctid?: string;
    params?: string;
    image?: string;
    tags?: string;
    /** Certificado para que Bryant (el asistente) lo use como fuente */
    certifiedForBryant?: boolean = false;
    /** Usuario que lo creó (columna created_user_id, apunta a common.user.id) */
    createdUserId?: number;
    /** Usuario que lo publicó, resuelto por el backend (solo id y username) */
    createdUser?: ReportUser;
    reportType?: ReportType;
    reportCategory?: ReportCategory;
    status?: Status = new Status();
    reportMenus: ReportMenu[];
}
